/**
 * Grymwyrd 認証機能（サインイン、登録、マジックリンク確認、パスワードリセット/設定）の日本語コピーカタログ。
 * キーは `packages/@gamecodex/world-ui/src/features/auth/*` 内の `t('auth.*')` の呼び出しと1対1でマッピングされます。
 * 値は正確な日本語翻訳文字列です。
 */
export const authJa = {
  // ── AuthShell ────────────────────────────────────────────────────────────
  'auth.shell.homeAriaLabel': 'Grymwyrd ホーム',
  'auth.shell.logoAlt': 'Grymwyrd',

  // ── OAuthButtons ─────────────────────────────────────────────────────────
  'auth.oauth.continueWithGoogle': 'Google で続行',
  'auth.oauth.continueWithDiscord': 'Discord で続行',

  // ── AccountVerifyPage ────────────────────────────────────────────────────
  'auth.verify.seoTitle': 'サインイン中',
  'auth.verify.seoDescription': 'Grymwyrd のサインインリンクを検証しています。',
  'auth.verify.errorMissingToken':
    'このサインインリンクのトークンが不足しています。サインインページから新しいリンクをリクエストしてください。',
  'auth.verify.errorInvalidOrExpired':
    'このサインインリンクは無効であるか、有効期限切れです。サインインページから新しいリンクをリクエストしてください。',
  'auth.verify.confirming': 'サインインを確認中…',
  'auth.verify.signedInHeading': 'サインインしました',
  'auth.verify.signedInAsPrefix': 'サインイン中：',
  'auth.verify.signedInAsSuffix': '。あなたの聖域へ移動しています…',
  'auth.verify.takingYouToSanctum': 'あなたの聖域へ移動しています…',
  'auth.verify.goNow': '今すぐ移動',
  'auth.verify.problemHeading': 'サインインリンクの問題',
  'auth.verify.backToSignIn': 'サインインに戻る',

  // ── LoginPage ────────────────────────────────────────────────────────────
  'auth.login.errorEnterEmailFirst': 'メールアドレスを入力してからリンクをリクエストしてください。',
  'auth.login.seoTitle': '敷居を越える',
  'auth.login.seoDescription': 'Grymwyrd にサインインし、永遠の薄明の中で伝説に戻ります。',
  'auth.login.eyebrow': '戻ってこい、放浪者よ',
  'auth.login.title': '敷居を越える',
  'auth.login.blurb': '名前と秘密の言葉を唱えて、永遠の薄明に再び入り直してください。',
  'auth.login.noPactYet': 'まだ契約していませんか?',
  'auth.login.forgeYourLegend': '伝説を紡ぎ出す',
  'auth.login.emailLabel': 'メールアドレス',
  'auth.login.emailPlaceholder': 'you@grymwyrd.com',
  'auth.login.passwordLabel': 'パスワード',
  'auth.login.forgotPassword': 'パスワードを忘れましたか?',
  'auth.login.submitBusy': '越えています…',
  'auth.login.submit': '入場',
  'auth.login.dividerOr': 'または',
  'auth.login.magicSentPrefix': 'サインインリンクが送信されました',
  'auth.login.magicSentTo': '宛先：',
  'auth.login.magicSentSuffix': '。メールボックスをご確認ください。',
  'auth.login.emailMeSignInLink': 'サインインリンクをメール送信',
  'auth.login.mockAuthPrefix': '開発用モック認証：どのメールアドレスでも機能します。使用：',
  'auth.login.mockAuthOr': 'または',
  'auth.login.mockAuthSuffix': '上位ロール向け。',

  // ── RegisterPage ─────────────────────────────────────────────────────────
  'auth.register.errorDisplayNameRequired': 'あなたの伝説が語られる名前を選んでください。',
  'auth.register.errorEmailRequired': 'あなたの契約を成立させるには、メールアドレスが必要です。',
  'auth.register.errorEmailInvalid': 'そのメールアドレスは正しくないようです。',
  'auth.register.errorPasswordTooShort': 'あなたの秘密の言葉は少なくとも8文字である必要があります。',
  'auth.register.errorMustBeAdult': 'Grymwyrd に参加するには、13 才以上である必要があります。',
  'auth.register.errorMustAcceptTerms': '契約（利用規約）に同意する必要があります。',
  'auth.register.errorIncomplete': 'あなたの契約の一部が不完全です。下を参照してください。',
  'auth.register.seoTitle': 'あなたの物語を始める',
  'auth.register.seoDescription':
    'Grymwyrd アカウントを作成し、アバターを育て、あなたの物語を正史とします。',
  'auth.register.eyebrow': 'Greywick 村を探索',
  'auth.register.title': 'あなたの物語を始める',
  'auth.register.blurb': 'あなたは幽玄の夢から目覚め、目を開けます…',
  'auth.register.alreadyBound': 'すでに薄明に束縛されていますか?',
  'auth.register.loginToExisting': '既存のアカウントにログイン',
  'auth.register.displayNameLabel': '表示名',
  'auth.register.displayNamePlaceholder': 'The Hollow Knight',
  'auth.register.displayNameHint': 'これはあなたの公開アバターと貢献に名前を付けます。',
  'auth.register.emailLabel': 'メールアドレス',
  'auth.register.emailPlaceholder': 'you@grymwyrd.com',
  'auth.register.passwordLabel': 'パスワード',
  'auth.register.passwordPlaceholder': '8文字以上',
  'auth.register.agreementsLegend': '同意事項',
  'auth.register.adultConfirmPrefix': '私は',
  'auth.register.adultConfirmEmphasis': '13才以上',
  'auth.register.adultConfirmSuffix': 'であることを確認します。',
  'auth.register.acceptPrefix': '私は',
  'auth.register.termsOfThePact': '契約の利用規約',
  'auth.register.acceptSuffix': 'に同意します。',
  'auth.register.submitBusy': '契約を成立させています…',
  'auth.register.submit': '現れ出る',
  'auth.register.dividerOr': 'または',
  'auth.register.mockAuthNote': '開発用モック認証：登録はローカルのみで保持されます。メールは送信されません。',
  'auth.register.lastUpdated': '最終更新 {date}',

  // ── ResetPasswordPage ────────────────────────────────────────────────────
  'auth.reset.errorInvalidEmail': 'あなたの契約に関連付けられたメールアドレスを入力してください。',
  'auth.reset.seoTitle': 'パスワードをリセット',
  'auth.reset.seoDescription':
    'パスワードを忘れましたか? ワンタイムリンクをメール送信します。クリックして新しいパスワードを選択してください。',
  'auth.reset.eyebrow': '秘密の言葉を失くした',
  'auth.reset.title': 'パスワードをリセット',
  'auth.reset.blurb':
    'あなたのメールアドレスをささやくと、ワンタイムリンクが暗闇へ送信されます。それをたどり、新しいパスワードを設定してください。',
  'auth.reset.rememberedAfterAll': 'やはり思い出しましたか?',
  'auth.reset.loginToExisting': '既存のアカウントにログイン',
  'auth.reset.successMessage':
    '{email} のアカウントが存在する場合、ワンタイムリンクが送信されています。それを開いてサインインし、新しいパスワードを設定してください。メールと迷惑メールフォルダを確認してください。',
  'auth.reset.sendToDifferentEmail': '別のメールアドレスに送信',
  'auth.reset.emailLabel': 'メールアドレス',
  'auth.reset.emailPlaceholder': 'you@grymwyrd.com',
  'auth.reset.submitBusy': '招集しています…',
  'auth.reset.submit': 'サインインリンクを送信',

  // ── SetPasswordPage ──────────────────────────────────────────────────────
  'auth.setPassword.errorTooShort': '少なくとも8文字のパスワードを選んでください。',
  'auth.setPassword.errorMismatch': 'これらのパスワードは一致しません。',
  'auth.setPassword.seoTitle': 'パスワードを設定',
  'auth.setPassword.seoDescription': 'Grymwyrd アカウント用の新しいパスワードを選択してください。',
  'auth.setPassword.eyebrow': '契約を成立させる',
  'auth.setPassword.title': '新しいパスワードを設定',
  'auth.setPassword.blurb':
    'あなたはサインインしています。新しいパスワードを選んでください。次回、マジックリンクと一緒に使用できます。',
  'auth.setPassword.ratherNot': 'むしろ嫌ですか?',
  'auth.setPassword.skipForNow': '今はスキップ',
  'auth.setPassword.successMessage': 'パスワードが設定されました。あなたの聖域へ移動しています…',
  'auth.setPassword.newPasswordLabel': '新しいパスワード',
  'auth.setPassword.newPasswordPlaceholder': '8文字以上',
  'auth.setPassword.confirmPasswordLabel': 'パスワードを確認',
  'auth.setPassword.confirmPasswordPlaceholder': 'もう一度入力してください',
  'auth.setPassword.submitBusy': '成立させています…',
  'auth.setPassword.submit': 'パスワードを保存',
} as const
